import * as React from 'react'
import classnames from 'classnames'

import cls from './FormInputGroup.module.scss'

const UikFormInputGroup = ({ children, className, Component, direction, horizontal, ...rest }) => (
  <Component
    className={classnames(className, {
      [cls.horizontal]: direction === 'horizontal' || horizontal,
      [cls.vertical]: !(direction === 'horizontal' || horizontal),
    })}
    {...rest}
  >
    {children}
  </Component>
)

UikFormInputGroup.defaultProps = {
  className: null,
  Component: 'div',
  direction: 'vertical',
  horizontal: false,
}

export default UikFormInputGroup
